import { theme } from '@bvi/mui-theme';

export const styles = {
  usersCount: { ml: '0.5em', color: theme.palette.grey['200'] },
};
